exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".step-2 .tree-container {\n  padding-left: 10px;\n  overflow: scroll;\n  height: 300px; }\n  .step-2 .tree-container .tree {\n    width: auto !important;\n    max-width: none !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/components/dataprotection/dataprotection-vc/common-ops/out-of-place-restore/step-2/step-2.scss
// module id = cTbJ
// module chunks = 0